<template>
  <div class="btn-group">
    <button class="btn btn-info btn-sm"
            :disabled="game.status === 'LIVE'"
            v-if="['NOT_PLAYED', 'SCHEDULED', 'FINISHED'].includes(game.status)"
            v-tooltip="$t('tooltip.rescheduleGame')"
            @click="scheduleGameModal(game)"><i class="fa fa-clock-o"></i></button>
    <button class="btn btn-warning btn-sm"
            :disabled="game.status === 'LIVE'"
            v-if="['SCHEDULED'].includes(game.status)"
            v-tooltip="$t('tooltip.cancelScheduledGame')"
            @click="cancelScheduledGame(game)"><i class="fa fa-times"></i></button>
    <le-schedule-game-modal ref="scheduleModal" @saved="onGameSaved"></le-schedule-game-modal>
  </div>

</template>

<script>
import GameService from '@/services/game.service'
import { useTimeline } from '@/use/useTimeline'
import { useGameSwap } from '@/use/useGameSwap'
import LeScheduleGameModal from '@/components/le/LeScheduleGameModal.vue'

export default {
  components: { LeScheduleGameModal },
  props: {
    game: Object
  },
  setup () {
    const { fetchCurrentTimeline } = useTimeline()
    const { swapGame, swapGameTimeAndVenue } = useGameSwap()
    return { fetchCurrentTimeline, swapGame, swapGameTimeAndVenue }
  },
  methods: {
    scheduleGameModal (game) {
      this.$refs.scheduleModal.open(game, this.$route.params.uuid)
    },
    onGameSaved (data) {
      this.$emit('changed', data)
      this.$mixpanel.track('Schedule game on game page')
    },
    cancelScheduledGame (game) {
      GameService.cancelScheduledGame(this.$route.params.uuid, game.uuid).then((res) => {
        game.time = res.data.time
        game.venue = res.data.venue
        game.code = res.data.code
        game.status = res.data.status
        this.fetchCurrentTimeline()
      }).finally(() => {
        this.$mixpanel.track('Cancel schedule game on game page')
      })
    }
  }
}
</script>
<style>
 .qr-button {
   display: block;
   border: 0;
   background: none;
   cursor: pointer;
 }
</style>
